import Spinner from "./Spinner";

const FullScreenSpinner = () => {
	return (
		<div
			style={{
				display: "flex",
				height: "75vh",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Spinner />
		</div>
	);
};

export default FullScreenSpinner;
